import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoLaptopComputer = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>LaptopComputer</title>
    <path
      d="M4.427 8.57c0-.71.576-1.286 1.286-1.286h20.572c.71 0 1.285.576 1.285 1.286v16a.143.143 0 0 1-.143.143H4.57a.143.143 0 0 1-.143-.143v-16Z"
      stroke="currentColor"
      strokeWidth={2}
    />
    <path d="M1.142 25.142h29.714" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export default SvgIcoLaptopComputer;
